module.exports = __webpack_public_path__ + "static/img/security-img.342666b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeatures/security-img.png
// module id = Rm/k
// module chunks = 0